import React from 'react';
import { useTranslation } from 'react-i18next';
import { Namespace } from '../../../translation/namespace';
import { asView } from '../../../_lib/ViewFetcher';

type ThemeColorDefaultViewProps = {
  value?: string;
};

export function ThemeColorDefaultView({ value }: ThemeColorDefaultViewProps) {
  const { t } = useTranslation(Namespace.ThemeColorForm);
  return (
    <div className="theme-color-form__default">
      <div className="theme-color-form__container">
        <p className="theme-color-form__input">
          <dfn className="theme-color-form__label">{t('default.labelPreviewInvisible')}</dfn>
          <span className="theme-color-form__color-hex">{value || t('default.noColor')}</span>
        </p>
        <p className="theme-color-form__preview" aria-hidden="true">
          <dfn className="theme-color-form__label">{t('edit.labelPreview')}</dfn>
          <span className="theme-color-form__color">&nbsp;</span>
        </p>
      </div>
    </div>
  );
}

export const PortalThemeDefaultView = asView(ThemeColorDefaultView);
